import { render } from "./ShareSheet.vue?vue&type=template&id=33d71040&ts=true"
import script from "./ShareSheet.vue?vue&type=script&lang=ts"
export * from "./ShareSheet.vue?vue&type=script&lang=ts"

import "./ShareSheet.vue?vue&type=style&index=0&id=33d71040&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__